import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import GetStartedRequestDemoSide from '../components/generic/GetStartedRequestDemoSide';
import ProductIntro from '../components/Product/ProductIntro';
import ProductInfo from '../components/Product/ProductInfo';
import GetStartedQuickly from '../components/Product/GetStartedQuickly';
import BenefitsMost from '../components/Product/BenefitsMost';
import TrackingComponent from '../components/Tracking/TrackingComponent';
import { lightThemeColors } from '../assets/style/colors';
import { ReactComponent as GridAssetIcon } from "../assets/decorations/greenBannerGrid.svg";
import { Helmet } from 'react-helmet-async';

const ProductPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const element = searchParams.get("scrollTo");
        if (element) {
            let scrollToElement = document.getElementById(element);
            scrollToElement.scrollIntoView({ behavior: "smooth" });
            setSearchParams((prev) => {
                prev.delete("scrollTo");
            });
        }
    }, []);


    return (
        <>
            <Helmet>
                <title>Grovs for Product Teams | Smarter User Journeys, Simplified</title>
                <meta
                    name="description"
                    content="Track essential user events, enable deep linking, and engage users across platforms—all from a single SDK. Grovs helps product teams simplify and scale growth without dev dependence."
                />
                <meta
                    name="keywords"
                    content="user journey tracking, product team tools, mobile SDK, app installs tracking, reactivation analytics, deep linking, in-app messaging, automated product engagement, Grovs product"
                />
                <meta name="robots" content="index, follow" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Grovs for Product Teams | Clear Data, Better Journeys" />
                <meta
                    property="og:description"
                    content="Understand user behavior, optimize deep links, and send targeted messages with ease. Grovs gives product teams the power to grow without complexity or extra dev work."
                />
                <meta property="og:url" content="https://www.grovs.io/product" />
                <meta
                    property="og:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Grovs for Product Teams | Easy Integration, Powerful Insights" />
                <meta
                    name="twitter:description"
                    content="One SDK. Instant insights. Grovs helps you measure installs, reactivations, app opens, and link views—plus smart deep linking and automated messaging for better engagement."
                />
                <meta
                    name="twitter:image"
                    content="https://appssemble-assets.s3.eu-north-1.amazonaws.com/linksquared/social-media-placeholder.jpg"
                />
            </Helmet>
            <Container>

                <ProductIntro />
                <ProductInfo />
                <GetStartedQuickly />
                <BenefitsMost />
                <GetStartedRequestDemoSide
                    bgColor={lightThemeColors.engagementBg}
                    gradientColor={"rgba(9, 58, 50, 1)"}
                    titleStyle={{ color: lightThemeColors.lightColor }}
                    subtitleStyle={{ color: lightThemeColors.lightColorFaded7 }}
                    gridDecoration={<GridAssetIcon />}
                    primaryButtonStyle={{ color: lightThemeColors.lightColor }}
                    primaryButtonVariant={lightThemeColors.footerBg}
                    outlineButtonStyle={{ color: lightThemeColors.darkColor, background: lightThemeColors.lightColor }}
                    outlineButtonVariant={lightThemeColors.lightColor}
                    title={"Ready for Clearer, Smarter Product Growth?"}
                    subtitle={"Grovs empowers your product team to improve user journeys, increase retention, and drive growth without complexity."}
                />
                <TrackingComponent />
            </Container>
        </>
    )
}

export default ProductPage

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
